
import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Checkbox, FormControlLabel } from '@mui/material'
import SaveDialog from '../../../components/Dialog/SaveDialog'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import NdaSupContract from './NdaSupContract'
import { nextStep, offNextButton } from '../../../store/slice/buttonSlice'
import { showErrorToast, showSuccessToast } from '../../../constToast/constToast'
import { useGetSupNDAQuery, usePostSupplierMutation } from '../../../store/api/supplierEvaluationApi'
import SupLoading from '../../../components/Loading/SupLoading'
import { updateSupNextButtonLoading } from '../../../store/slice/otherSlice'

export default function NdaSup({ checkedItems, setCheckedItems, companyData, vendorId, reviseSup }) {

  const [valid, setValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  const [value, setValue] = useState('0')
  const [checkboxValue, setCheckboxValue] = useState({})


  const { data, isLoading } = useGetSupNDAQuery(vendorId);


  // useEffect(() => {
  //   if (checkedItems?.length > 0) {
  //     setCheckedItems(checkedItems)
  //   }
  //   else if (data?.data?.some(item => item.isAgreed)) {
  //     setCheckedItems(data?.data.filter((item) => item.isAgreed))
  //   }
  //   else { setCheckedItems([]) }
  // }, [setCheckedItems, data])

  useEffect(() => {
    if (checkedItems?.length > 0) {
      setCheckedItems(checkedItems)
    }
    else if (data?.data[0]) {
      setCheckedItems([data?.data[0]])
    }
    else { setCheckedItems([]) }
  }, [setCheckedItems, data])


  const handleCheckChange = (item, isChecked) => {
    const updatedCheckedItems = isChecked
      ? [...checkedItems, item]
      : checkedItems.filter((checkedItem) => checkedItem.businessUnitId !== item.businessUnitId)

    setCheckedItems(updatedCheckedItems)
  }

  const handleCheck = (id) => {
    setCheckedItems((prevItems) =>
      prevItems.map((x) => (x.businessUnitId === id ? { ...x, isAgreed: !x.isAgreed } : x))
    )
  }


  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const handleCheckboxChange = (event, tabValue) => {
    setCheckboxValue((prevCheckboxValue) => ({
      ...prevCheckboxValue,
      [tabValue]: event.target.checked,
    }))

    const currentIndex = parseInt(tabValue)
    if (currentIndex !== checkedItems?.length - 1 && event.target.checked) {
      const nextTabValue = (currentIndex + 1).toString()
      setValue(nextTabValue)
    }
  }

  const dispatch = useDispatch();
  useEffect(() => {
    let findFalse = checkedItems.filter((item) => item.isAgreed === false)
    const isValid = checkedItems.length > 0 && checkedItems.every((item) => item.isAgreed === true)

    setValid(isValid)
    setErrorMessage(`${findFalse.map((x) => x.businessUnitName)} agreement is not selected`)

  }, [checkedItems, dispatch])

  const nextClicked = useSelector((state) => state.buttonSlice.nextClicked)

  useEffect(() => {
    if (nextClicked) {
      dispatch(offNextButton())

      if (valid) {
        dispatch(nextStep());
        dispatch(updateSupNextButtonLoading(true))
      } else if (!valid) {
        showErrorToast(errorMessage)
      }


    }
  }, [nextClicked, dispatch, valid, errorMessage])


  const [saveMutation] = usePostSupplierMutation();

  const handleSave = async () => {


    if (valid) {
      const updatedItemsNda = checkedItems.map(item => {
        return { ...item, vendorId: reviseSup ? 0 : vendorId };
      });

      const saveData = await saveMutation({
        companyInformation: {
          ...companyData,
          vendorId: reviseSup ? 0 : vendorId
        },
        nonDisclosureAgreement: updatedItemsNda, isRevise: reviseSup
      });

      if (saveData?.data?.statusCode === 200) {
        showSuccessToast(`Succesfully saved`)
      } else { showErrorToast('Error') }
    } else {
      showErrorToast(errorMessage)
    }
  }


  useEffect(() => {
    if (!isLoading) {
      dispatch(updateSupNextButtonLoading(false))
    }
  }, [isLoading, dispatch])

  return (
    <>
      {!isLoading ? (
        <>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            {/* <div>
              {data?.data?.map((item, index) => (
                <div key={index}>
                  <FormControlLabel
                    label={item?.businessUnitName}
                    control={
                      <Checkbox
                        checked={checkedItems?.some(
                          (checkedItem) => checkedItem?.businessUnitId === item?.businessUnitId
                        )}
                        onChange={(e) => handleCheckChange(item, e.target.checked)}
                      />
                    }
                  />

                </div>
              ))}
            </div> */}

            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="business units">
                  {checkedItems?.map((tab, index) => (
                    <Tab key={tab.businessUnitId} label={'GL Group'} value={index.toString()} />
                  ))}
                </TabList>
              </Box>

              {checkedItems?.map((item, index) => (
                <TabPanel key={index} value={index.toString()}>
                  <NdaSupContract
                    checked={checkboxValue[index] || false}
                    index={index}
                    handleCheck={handleCheck}
                    checkedItems={checkedItems}
                    companyInformation={companyData}
                    businessUnitId={item.businessUnitId}
                    handleCheckboxChange={handleCheckboxChange}
                  />
                </TabPanel>
              ))}
            </TabContext>
          </Box>
          <SaveDialog text="NDA" handleSave={handleSave} />
        </>
      ) : <><SupLoading /></>}
    </>
  )
}